/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Manager_Create_Team_ButtonInputs */

const en_team_manager_create_team_button = /** @type {(inputs: Team_Manager_Create_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Create Team`)
};

const fr_team_manager_create_team_button = /** @type {(inputs: Team_Manager_Create_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Créer une équipe`)
};

const de_team_manager_create_team_button = /** @type {(inputs: Team_Manager_Create_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team erstellen`)
};

const it_team_manager_create_team_button = /** @type {(inputs: Team_Manager_Create_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crea squadra`)
};

const ru_team_manager_create_team_button = /** @type {(inputs: Team_Manager_Create_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Создать команду`)
};

const es_team_manager_create_team_button = /** @type {(inputs: Team_Manager_Create_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Crear equipo`)
};

const zh_cn2_team_manager_create_team_button = /** @type {(inputs: Team_Manager_Create_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`创建团队`)
};

const ja_team_manager_create_team_button = /** @type {(inputs: Team_Manager_Create_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームを作成`)
};

const hi_team_manager_create_team_button = /** @type {(inputs: Team_Manager_Create_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम बनाएं`)
};

const pt_pt2_team_manager_create_team_button = /** @type {(inputs: Team_Manager_Create_Team_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Criar equipe`)
};

/**
* | output |
* | --- |
* | "Create Team" |
*
* @param {Team_Manager_Create_Team_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const team_manager_create_team_button = /** @type {((inputs?: Team_Manager_Create_Team_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Manager_Create_Team_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_team_manager_create_team_button(inputs)
	if (locale === "de") return de_team_manager_create_team_button(inputs)
	if (locale === "it") return it_team_manager_create_team_button(inputs)
	if (locale === "ru") return ru_team_manager_create_team_button(inputs)
	if (locale === "es") return es_team_manager_create_team_button(inputs)
	if (locale === "zh-CN") return zh_cn2_team_manager_create_team_button(inputs)
	if (locale === "ja") return ja_team_manager_create_team_button(inputs)
	if (locale === "hi") return hi_team_manager_create_team_button(inputs)
	if (locale === "pt-PT") return pt_pt2_team_manager_create_team_button(inputs)
	return en_team_manager_create_team_button(inputs)
});